// import axios from "axios";

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
// });

// export default api;

import axios from "axios";

// 1. Create instance with withCredentials enabled for cookies
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // ⚡ Needed to send/receive HttpOnly refreshToken cookie
});

// In-Memory Token Management (Prevents XSS attacks)
let isRefreshing = false;
let failedQueue = [];

let accessToken = localStorage.getItem("accessToken") || null;

export const setAccessToken = (token) => {
  accessToken = token;
  if (token) {
    localStorage.setItem("accessToken", token);
  } else {
    localStorage.removeItem("accessToken");
  }
};

export const getAccessToken = () => accessToken;
console.log("Current accessToken:", accessToken);

// Queue processing for parallel requests during refresh
const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// =======================================================
// REQUEST INTERCEPTOR: Attach Access Token Automatically
// =======================================================
api.interceptors.request.use(
  (config) => {
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// =======================================================
// RESPONSE INTERCEPTOR: Auto Refresh Expired Access Token
// =======================================================
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Trigger refresh if backend returns 401/403 and request hasn't been retried yet
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry
    ) {
      // Prevent loop if the refresh endpoint itself fails
      if (originalRequest.url.includes("/auth/refresh")) {
        setAccessToken(null);
        window.location.href = "/auth/sign-in"; // 👈 FIXED: Added leading slash
        return Promise.reject(error);
      }

      // Handle simultaneous API requests while refreshing
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // Call backend refresh route
        const res = await api.post("/auth/refresh");
        const newAccessToken = res.data.accessToken;

        setAccessToken(newAccessToken);
        processQueue(null, newAccessToken);

        // Retry original request
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        setAccessToken(null);
        window.location.href = "/auth/sign-in"; // 👈 FIXED: Added leading slash
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;